/* eslint-disable max-len */
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import CallOrderForm from '../../CallOrderForm/CallOrderForm';
import './ServiceOrder.scss';

export default function ServiceOrder() {
  const { t } = useTranslation('personal_account', { keyPrefix: 'service_order' });

  useEffect(() => {
    window.scrollTo({
      left: 0,
      top: 0,
      behavior: 'instant',
    });
  }, []);

  useEffect(() => {
    const header = document.querySelector('.Header.fixed');
    const serviceOrder = document.querySelector('.ServiceOrder');
    const footer = document.querySelector('.Footer');
    const minimumRequiredHeight = document.documentElement.clientHeight - (header.offsetHeight + footer.offsetHeight);

    serviceOrder.style.minHeight = `${minimumRequiredHeight}px`;
  }, []);

  return (
    <section className="ServiceOrder">
      <div className="wrapper">
        <div className="service-order-content">
          <h1 className="heading-one">
            {t('heading')}
          </h1>
          <p className="description">
            {t('description')}
          </p>
          <CallOrderForm />
        </div>
      </div>
    </section>
  );
}
